import Swal from './swal' // lazy sweetalert2 (HAP-4635)
import axios from "axios"

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email ?? "").trim().toLowerCase());
}

async function subscribeToMailChimp({ email, list, source, alert }) {

    let lists = {
        master: '816047355d',
        devotional: '5fbac827f8'
    }

    let listId = lists[list]

    if (!listId) {
        console.error(`"${list}" is not a valid email list`)
        return false
    }
    if (!source) {
        console.error(`You must provide a subscription source`)
        return false
    }

    if (!validateEmail(email)) {
        new Swal('Invalid Email', `"${email}" is not a valid email address`, 'warning')
        console.error(`"${email}" is not a valid email address`)
        return false
    }

    try {
        await axios.post(`https://churchandfamilylife.us2.list-manage.com/subscribe/post?u=12eae89c5f8969e490844c75a&id=${listId}`, { EMAIL: email, MMERGE3: source })
            .then(response => { if (alert) new Swal('Subscribed!', 'Thank you for subscribing.', 'success') })
            // MC apparently doesn't give a proper error message we can read at the time of writing this...
            .catch(response => { if (alert) new Swal('Subscribed!', 'Thank you for subscribing.', 'success') })
    } catch (e) {
        console.log(e)
    }

    // NOTE: this posts cross-origin to list-manage.com, which answers opaquely — there is no
    // readable success signal, so `true` means "a valid address was submitted", not "Mailchimp
    // accepted it". Callers firing a conversion off this must treat it as submission-confirmed
    // rather than server-confirmed (HAP-3876).
    return true
}

export { subscribeToMailChimp, validateEmail }
